import React from 'react';
import { Row } from 'react-bootstrap';
import LeftSection from './LeftSection';
import RightSection from './RightSection';
import Skeleton from '../../../common/skeleton';
import './SearchResultsCard.scss';

const SearchDetailsSkeleton = () => {
  return (
    <>
      <Row className="mx-0 mt-3">
        <Skeleton
          height={24}
          width={350}
          count={1}
          containerClassName={'name-address-info'}
        />
      </Row>
      <Row className="row-eq-height mt-3">
        <LeftSection />
        <RightSection />
      </Row>
    </>
  );
};

export default SearchDetailsSkeleton;
